@if (hero(); as content) {
  <fin-cms-json-content class="destinationHero" [template$]="{ main: [content] } | finToObservable" />
}

<section class="destination-main ms-xxlarge-y">
  <div class="grid-col-12 grid-max-width no-row-gap">
    <!-- Main left (first element) -->
    @if (mainLeft(); as content) {
      @if (isNewBrand() && title()) {
        <h2 class="col-1-12 font-headline-medium">{{ title() }}</h2>
      }
      <fin-cms-json-content
        class="destination-main__left col-1-12 md-col-1-8"
        [template$]="{ main: [content] } | finToObservable"
      />
    }
    <!-- Main right (2nd and 3rd element) -->
    @if (mainRight(); as content) {
      <section class="destination-main__right col-1-12 md-col-9-12">
        @for (item of content; track $index) {
          <fin-cms-json-content [template$]="{ main: [item] } | finToObservable" />
          @if (!isNewBrand()) {
            <hr role="presentation" />
          }
        }
      </section>
    }
    <!-- Main full width (rest of the items) -->
    @if (remainingContent(); as content) {
      <fin-cms-json-content
        class="destination-main__bottom col-1-12"
        [class.ms-xxlarge-y]="!isNewBrand()"
        [template$]="content | finToObservable"
      />
    }
  </div>
</section>
